import { jsonUploadCall } from '../../helpers/api/api'
import { login } from '../../store/actions/auth'

async function validateInputs(refs) {
    for (let ref in refs) {
        if (await refs[ref].validateInput() === false) return false
    }
    return true
}
async function onFormSubmit(state, refs, endPoint) {
    if (await validateInputs(refs) === false) return

    try{
        const result = await jsonUploadCall(endPoint, state)
        return Promise.resolve(result)

    }catch(err){
        if (err.message === "Request failed with status code 401") {
            login("")
        }
    }

}

export default onFormSubmit
